// extracted by mini-css-extract-plugin
export default {"wrapper":"ticketLink_wrapper__ARyXO","cell":"ticketLink_cell__zcHRy","text":"ticketLink_text__W00cd","icon":"ticketLink_icon__Xi3wY","btn":"ticketLink_btn__C6iVL"};